import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Papa from 'papaparse';
import PlayerStatistics from './PlayerStatistics';
import TopGoalscorers from './TopGoalscorers';
import ShuffleTeams from './ShuffleTeams';
import PlayerComparison from './PlayerComparison';
import Menubar from './Menubar';

function App() {
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        fetch('/data/player_statistics.csv')
            .then(res => res.text())
            .then(csv => {
                Papa.parse(csv, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (result) => setPlayers(result.data),
                });
            });
    }, []);

    return (
        <Router>
            <Menubar />
            <Routes>
                <Route path="/" element={<PlayerStatistics />} />
                <Route path="/top-goalscorers" element={<TopGoalscorers />} />
                <Route path="/shuffle-teams" element={<ShuffleTeams />} />
                <Route path="/player-comparison" element={<PlayerComparison players={players} />} />
            </Routes>
        </Router>
    );
}

export default App;